<div class="process-card">

    <div class="card-header text-center">
        <img src="/assets/icons/avyna/logo.svg" alt="Avyna" class="brand-logo mb-3" />
    </div>

    <div class="content-area">
        <div class="request-view animate-fade-in">
            <mat-icon class="request-icon">workspace_premium</mat-icon>
            <h2 class="request-title">{{ 'app.billing.licences.request_access.title' | translate }}</h2>
            <p class="request-desc">{{ 'app.billing.licences.request_access.body' | translate }}</p>

            @if (facade.isLoading()) {
            <div class="status-line mt-3">
                <mat-spinner diameter="20"></mat-spinner>
                <span>{{ 'shared.general.labels.loading' | translate }}</span>
            </div>
            } @else if (facade.lastRequestedAt()) {
            <p class="status-line mt-3 mb-0">
                {{ 'app.billing.licences.request_access.last_sent' | translate: lastSentParams() }}
            </p>
            } @else {
            <p class="status-line mt-3 mb-0">
                {{ 'app.billing.licences.request_access.never_sent' | translate }}
            </p>
            }

            @if (facade.isThrottled()) {
            <p class="status-line mb-0">
                {{ 'app.billing.licences.request_access.next_allowed' | translate: nextAllowedParams() }}
            </p>
            }

            <div class="actions-area mt-4">
                <button mat-flat-button class="action-btn" [disabled]="facade.isThrottled() || facade.isLoading()"
                    (click)="requestAccess()">
                    {{ 'app.billing.licences.request_access.action' | translate }}
                </button>
                <button mat-stroked-button class="action-btn mt-2" (click)="logout()">
                    {{ 'shared.general.dialogs.logout.title' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="card-footer">
        <mat-icon class="secure-icon">lock</mat-icon>
        <span>{{ 'app.auth.callback.footer' | translate }}</span>
    </div>
</div>
